import EA from 'helpers/init';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default EA.Methods.experiencesSlider = ($this) => {
    const slider = $this.querySelector('.swiper');
    const prev = $this.querySelector('.prev');
    const next = $this.querySelector('.next');

    new Swiper(slider, {
        modules: [Navigation],
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: true,
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        breakpoints: {
            601: {
                slidesPerView: 1.7,
                spaceBetween: 20
            },
            769: {
                slidesPerView: 2.5,
                spaceBetween: 20
            },
            1001: {
                slidesPerView: 3,
                spaceBetween: 18
            }
        }
    });
};
